module.exports = __webpack_public_path__ + "img/collection-engagementRingsClassic@2x.87618d4.webp";